import { ExceptionClient } from '../services/ohl.virtualCenter.api';

const exceptionClient = new ExceptionClient(process.env.REACT_APP_PUBLIC_API);

class ExceptionsProvider {


    getList = (resource, params) => {
            const { page, perPage } = params.pagination;
            let { field, order } = params.sort;
    
            return exceptionClient.list({
                pageNumber: page,
                pageSize: perPage,
                orderField: field,
                orderAsc: order === 'ASC',
                ...params.filter
            }).then((data) => {
                return {
                    data: data.elements,
                    total: data.total,
                }
            });
        }

    
    
        getManyReference = (resource, params) => {
            const { page, perPage } = params.pagination;
    
            return exceptionClient.list({
                contractId: params.id,
                pageNumber: page,
                pageSize: perPage,
                ...params.filter
            }).then(
                res => {
                    return {
                        data: res.elements,
                        total: res.total
                    }
                }
            )
        }
};

export default new ExceptionsProvider();